import LinkButton from '@/decodo/components/atoms/LinkButton';
import React from 'react';

export type SearchResultProps = {
  slug: string;
  title?: string;
};

export function SearchResult({ slug, title }: SearchResultProps) {
  return (
    <div className='box-border min-h-9'>
      <LinkButton
        href={`/${slug}`}
        variant='text'
        classNames={{
          inner: 'mb-3',
          root: 'px-6 w-full h-full max-w-[600px] justify-start',
        }}
        textWrap
      >
        {title}
      </LinkButton>
    </div>
  );
}

export type SearchResultListProps = {
  results: SearchResultProps[];
};

export default function SearchResultList({ results }: SearchResultListProps) {
  return (
    <div>
      {results.map((item, index) => (
        <SearchResult key={index} {...item} />
      ))}
    </div>
  );
}
